import './About.css'
export default function About() {
    return (
        <section className=" text-white py-5 about">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <p className="fw-lighter fs-4 m-0">About</p>
                        <h2>My Story</h2>
                    </div>
                    <div className="col-md-6 d-flex justify-content-between gap-2 align-items-start ">
                        <span className="hero-divider-v"></span>
                        <p className='h5 lh-base'>I started my freelance career as a graphic designer. I've always loved playing I started my Bewulance ca with Photoshop & Illustrator. The first job got in Fiverr was a logo design job. The second one was a website user interface design joti. After the, I got much sharm working as a web designer. Then, I started to leam some coding languages like HTML, CSS, JavaScript, Bootstrap, Taiwind, Sitra atc. from TrewCocaCcamp Stil im keraming a lat. My god is to become a full-stark developer.</p>
                        {/* <div className="bg-secondary rounded" style={{ height: '250px' }}>About Image</div> */}
                    </div>
                </div>
            </div>
        </section>
    );
}